import React, { Component } from 'react'
import { connect } from 'react-redux'
import loadingImagen from '../../assets/images/logo-animado-2.gif'
import classNames from 'classnames/bind'
import './loading.css'

export class Loading extends Component {

  constructor(props) {
    super(props)

    this.state = {
      show: false,
      hide: false
    }
  }

  componentDidMount() {
    const { force } = this.props
    if (force) {
      this.setState({
        show: true,
        hide: false
      }, () => {
        setTimeout(() => {
          this.setState({
            hide: true
          }, () => {
            setTimeout(() => {
              this.setState({
                show: false
              })
            }, 2000);
          })
        }, 500);
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { isFetching, force, customFetch, isCustomFetching } = this.props
    if (force) return
    if (customFetch) {
      if (prevProps.isCustomFetching !== isCustomFetching) {
        if (isCustomFetching) {
          this.setState({
            show: true,
            hide: false
          })
        } else {
          this.setState({
            hide: true
          }, () => {
            setTimeout(() => {
              this.setState({
                show: false
              })
            }, 1500);
          })
        }
      }
      return
    }
    if (prevProps.isFetching !== isFetching) {
      if (isFetching) {
        this.setState({
          show: true,
          hide: false
        })
      } else {
        this.setState({
          hide: true
        }, () => {
          setTimeout(() => {
            this.setState({
              show: false
            })
          }, 1500)
        })
      }
    }
  }

  render() {
    const { show, hide } = this.state
    const classLoading = classNames('loading-container', {
      'loading-hide': hide
    })
    return (
      <React.Fragment>
        {show && <div className={classLoading}><img src={loadingImagen} alt='Loading' /></div>}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isFetching: state.authUser.isFetching
  }
}

export default connect(mapStateToProps)(Loading)